import { apiClient } from '../api/client'
import { API_ENDPOINTS } from '../api/endpoints'

export interface ScreenViewIceServer {
  urls: string
  username?: string
  credential?: string
}

export interface ScreenViewPendingRequest {
  requestGuid: string
  displayCode: string
  managementUserName?: string
  customerName?: string
  licenseName?: string
  createdAt: string
  expiresAt: string
  secondsRemaining: number
  messageAr: string
  messageEn: string
}

export interface ScreenViewRequestDto {
  id: number
  requestGuid: string
  displayCode: string
  licenseId: number
  customerName?: string
  deviceId: string
  deviceName?: string
  machineName?: string
  licenseName?: string
  managementUserName?: string
  customerUserName?: string
  status: string
  createdAt: string
  expiresAt: string
  approvedAt?: string
  endedAt?: string
  endReason?: string
  secondsRemaining: number
  sessionGuid?: string
  sessionDisplayCode?: string
  sessionToken?: string
  connectionStatus?: string
  userMessage: string
  iceServers?: ScreenViewIceServer[]
  maxFps: number
  maxWidth: number
  maxHeight: number
}

export interface ScreenViewSessionDto {
  id: number
  sessionGuid: string
  displayCode: string
  requestGuid: string
  licenseId: number
  customerName?: string
  licenseName?: string
  deviceId: string
  deviceName?: string
  machineName?: string
  customerUserName?: string
  managementUserName?: string
  mode: string
  connectionStatus: string
  requestTime: string
  approvedAt?: string
  startedAt: string
  endedAt?: string
  durationSeconds: number
  endReason?: string
  endReasonLabel?: string
  userMessage: string
  iceServers?: ScreenViewIceServer[]
}

export async function getScreenViewPending(): Promise<ScreenViewPendingRequest[]> {
  const res = await apiClient.get(API_ENDPOINTS.screenView.pending)
  return res.data || []
}

export async function approveScreenView(requestGuid: string): Promise<ScreenViewRequestDto> {
  const res = await apiClient.post(API_ENDPOINTS.screenView.approve(requestGuid))
  return res.data
}

export async function rejectScreenView(requestGuid: string): Promise<ScreenViewRequestDto> {
  const res = await apiClient.post(API_ENDPOINTS.screenView.reject(requestGuid))
  return res.data
}

export async function endScreenViewSession(sessionGuid: string, reason: string): Promise<ScreenViewSessionDto> {
  const res = await apiClient.post(API_ENDPOINTS.screenView.endSession(sessionGuid), { reason })
  return res.data
}

export function screenViewErrorMessage(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: { message?: string } } })?.response?.data
  return data?.message || fallback
}
